import { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../apiConfig";
import BannerPageTitle from "../Components/UIcomponents/BannerPageTitle";

function Constitution() {
    const [content, setContent] = useState('');

    useEffect(() => {
        const language = document.getElementById('language')?.value || '1';
        axios.get(`${API_BASE_URL}/about/${language}`).then((res) => {
            setContent(res.data.about.constitution);
        });
    }, []);

    return (
        <div style={{ background: '#f4f6fa', minHeight: '100vh', paddingBottom: '4rem' }}>
            <BannerPageTitle 
                title='Constitution' 
                subtitle='The governing rules and regulations of BTCL'
            />
            <div style={{ 
                maxWidth: '900px', 
                margin: '-40px auto 0 auto', 
                padding: '3rem 2.5rem', 
                minHeight: '50vh', 
                background: '#ffffff', 
                borderRadius: '12px', 
                boxShadow: '0 10px 30px rgba(0,0,0,0.08)',
                position: 'relative',
                zIndex: 10,
                borderTop: '4px solid var(--blue)'
            }}>
                <div dangerouslySetInnerHTML={{ __html: content }} style={{ 
                    font: '400 1.1rem/1.8 var(--fontBody), sans-serif', 
                    color: '#333',
                    textAlign: 'justify'
                }}></div>
            </div>
        </div>
    );
}

export default Constitution;
